module.exports = __webpack_public_path__ + "media/images/password-5e05fa5f80269dc67e3ed0a83ac3b64d.svg";